module.exports = __webpack_public_path__ + "static/about-us-02-ea1d80b9e1363cd461a7f3d7c0efe6d3.png";